import { ITypography, Typography } from '@sanlam-glacier/app-common/components';
import { Block, Grid, BlockProps } from '@sanlam-glacier/app-common/modules/grid';
import { PropsWithChildren } from 'react';

interface TextProps {
  className?: string;
  align?: ITypography['align'];
  variant?: ITypography['variant'];
  weight?: ITypography['weight'];
  color?: ITypography['color'];
  disabled?: ITypography['disabled'];
}

interface TextBlockProps extends BlockProps, TextProps {}

export const Text = ({
  align = Typography.ALIGN.LEFT,
  variant = Typography.VARIANT.H3,
  weight = Typography.WEIGHT.MEDIUM,
  color = Typography.COLOR.DEFAULT,
  className,
  children,
  disabled
}: PropsWithChildren<TextProps>) => {
  return (
    <Typography
      disabled={disabled}
      align={align}
      variant={variant}
      weight={weight}
      color={color}
      className={className}
    >
      {children}
    </Typography>
  );
};

export const TextBlock = ({
  align = Typography.ALIGN.LEFT,
  variant = Typography.VARIANT.H3,
  weight = Typography.WEIGHT.MEDIUM,
  sm = 12,
  color = Typography.COLOR.DEFAULT,
  children,
  disabled,
  ...blockProps
}: PropsWithChildren<TextBlockProps>) => {
  return (
    <Block {...blockProps} sm={sm}>
      <Text disabled={disabled} align={align} variant={variant} weight={weight} color={color}>
        {children}
      </Text>
    </Block>
  );
};

export const TextBlockRow = ({ children, ...blockProps }: PropsWithChildren<TextBlockProps>) => {
  return (
    <Grid row>
      <TextBlock {...blockProps}>{children}</TextBlock>
    </Grid>
  );
};

export const TextBlockHeader = ({ children, ...blockProps }: PropsWithChildren<TextBlockProps>) => {
  return (
    <TextBlock {...blockProps} variant={Typography.VARIANT.H4} weight={Typography.WEIGHT.MEDIUM}>
      {children}
    </TextBlock>
  );
};

export const TextBlockSubHeader = ({
  children,
  ...blockProps
}: PropsWithChildren<TextBlockProps>) => {
  return (
    <TextBlockRow
      {...blockProps}
      variant={Typography.VARIANT.B2}
      weight={Typography.WEIGHT.MEDIUM}
      color={Typography.COLOR.SECONDARY}
    >
      {children}
    </TextBlockRow>
  );
};
